import React from 'react'
import { Grid, Header, Segment, Card, Button } from 'semantic-ui-react'

import SEO from 'lib/components/SEO'
import Page from 'lib/components/Page'
import useUser from 'lib/hooks/useUser'

import PricingQuestions from './PricingQuestions'

const UserButton = ({ loggedIn }: { loggedIn: boolean }) => (
  <Button
    as="a"
    href={loggedIn ? '/user/subscription' : '/signup'}
    primary
    fluid
    size="large"
  >
    {!loggedIn ? 'Sign Up Now' : 'Subscribe Now'}
  </Button>
)

const Pricing = () => {
  const [user] = useUser()

  return (
    <Page
      header="Simple and affordable pricing"
      subheader="Features to make your life easier and keep you safe. No hidden fees."
    >
      <SEO
        title="Protect yourself from recalled products, affordable and reliable | Recall Monitor"
        description="Recall Monitor can send you email and text alerts as soon as product recalls are issued. Affordable and reliable, never search for recalls again - they come to you!"
        canonical="https://recallmonitor.ca/pricing"
      />

      <p>
        Recall Monitor subscription has two no-nonsense options: $3.99 monthly
        or $40 yearly.
      </p>

      <Grid columns={2} stackable>
        <Grid.Column stretched>
          <Card
            css={{
              'margin-right': '0 !important',
            }}
            fluid
            color="blue"
            header="$40 / year"
            meta="Billed annually"
            description="Pay upfront and get 2 months free. $3.33 per month"
            extra={<UserButton loggedIn={!!user.auth} />}
          />
        </Grid.Column>

        <Grid.Column stretched>
          <Card
            css={{
              'margin-right': '0 !important',
            }}
            fluid
            color="blue"
            header="$3.99 / month"
            meta="Billed monthly"
            description="Try for a while before committing."
            extra={<UserButton loggedIn={!!user.auth} />}
          />
        </Grid.Column>
      </Grid>

      <PricingQuestions />

      <Segment
        secondary
        textAlign="center"
        style={{ margin: '1rem auto 1rem auto' }}
      >
        <Header as="h5">
          Are you a charity, or come from an under-privileged or a disadvantaged
          background?
        </Header>
        <p>
          Peace of mind should have no cost. The subscription fee keeps this
          service running, but we recognize not everyone is able to pay. Another
          way to support Recall Monitor is via spreading the word-of-mouth.
        </p>
        <p>
          Email{' '}
          <a href="mailto:contact@recallmonitor.ca">contact@recallmonitor.ca</a>{' '}
          describing your situation. For a Tweet, Facebook or Instagram post you
          will get a 3 month subscription free of charge, or 50% off of your
          subscription price.
        </p>
      </Segment>
    </Page>
  )
}

export default Pricing
